import classnames from "classnames";
import { inject, observer } from 'mobx-react';
import React, { Component, Fragment } from "react";
import { Image, Menu, Plus, Search, Star, ChevronLeft, ChevronRight, ChevronDown } from "react-feather";
import {
  Button, Card, CardBody, Col, FormGroup, Input, Row, PaginationLink,
  Pagination, PaginationItem, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem
} from "reactstrap";
import "../../assets/scss/pages/data-list.scss";
import "../../assets/scss/plugins/extensions/react-paginate.scss";
import { history } from "../../history";
import { withFirebase } from '../../services/Firebase';
import ViewContent from "./details";
import ShareContent from "./share";
import EditContent from "./edit";
import ReactTags from 'react-tag-autocomplete';
import processingImg from "../../assets/img/pages/404.png";
import PaginatorComp from "../common/PaginatorComp";

@withFirebase
@inject('libraryStore', 'createMeetingStore', 'sessionStore')
@observer
class LibraryList extends Component {

  state = {
    sortDropDownOpen: false,
    rowsPerPageDropDownOpen: false,
    showModal: false
  }

  componentDidMount() {
    let { libraryStore } = this.props;
    libraryStore.loadDocuments();
  }

  handleSidebar = (show , addNew = false, uid) => {
    const { libraryStore } = this.props;
    if(show){
      libraryStore.changeScreenState({
        editMode: !addNew,
        createMode: addNew
      });
      if (addNew == true) {
        libraryStore.createNewRow();
      } else {
        libraryStore.loadDocumentForEdit(uid);
      }
    } else {
      libraryStore.changeScreenState({
        editMode: false,
        createMode: false
      })
    }
    
  }


  showDocumentDetailSidebar = item => {
    let { libraryStore } = this.props;
    libraryStore.loadDocumentForEdit(item.uid);
    libraryStore.changeScreenState({
      editMode: false,
      createMode: false,
      detailMode: true
    })
  }

  selectCurentContent = (content, contentSharing) => {
    const { libraryStore } = this.props;
    // const { contentSharing } = sessionStore;
    if (contentSharing === "customer") {
      libraryStore.setDocument(content);
      this.setState({
        shareContent: true
      })
    } else if (contentSharing === "activity") {
      libraryStore.setDocument(content);
      this.props.toggle();
    }
    else if (contentSharing === "meeting") {
      const { createMeetingStore } = this.props;
      createMeetingStore.setDocument(content);
      this.props.toggle();
    }
  }

  toggleViewSidebar = (show) => {
    const { libraryStore } = this.props;
    libraryStore.changeScreenState({
      detailMode: show
    })
  }

  toggleShareSidebar = (show) => {
    const { libraryStore } = this.props;
    libraryStore.changeScreenState({
      shareMode: show
    })
  }

  onNext = (n) => {
    const { libraryStore } = this.props;
    libraryStore.setPaginator({ pageNumber: n, fbOperation: 'Next' });
    libraryStore.loadDocuments();
  }

  onPrev = (n) => {
    const { libraryStore } = this.props;
    libraryStore.setPaginator({ pageNumber: n, fbOperation: 'Prev' });
    libraryStore.loadDocuments();
  }

  goToPage = (n) => {
    const { libraryStore } = this.props;
    libraryStore.setPaginator({ pageNumber: n });
    libraryStore.loadDocuments();
  }

  updateSearchTerm = (event) => {
    const { libraryStore } = this.props;
    libraryStore.setDocumentFilter({ searchTerm: event.target.value })
    if (event.target.value && event.target.value.length > 3)
      libraryStore.loadDocuments();
  }

  sortBy = (field) => {
    const { libraryStore } = this.props;
    libraryStore.setDocumentFilter({ sortBy: field })
    libraryStore.loadDocuments();
  }

  setRowsPerPage = (n) => {
    const { libraryStore } = this.props;
    libraryStore.setPaginator({ rowsPerPage: n });
    libraryStore.loadDocuments();
  }

  render() {
    const { shareContent, sortDropDownOpen, rowsPerPageDropDownOpen } = this.state;
    const { screen, documentCollection, documentPaginator, documentFilter } = this.props.libraryStore;
    const { editMode, createMode, list, detailMode, shareMode } = screen;
    const { isLoading } = list; 
    const showSidebar = screen.editMode || screen.createMode;
    const { documents } = documentCollection;

    const noData = (
      <div className="loading_conatiner">
        <div className="">
          <div>No Documents to Show</div>
        </div>
      </div>
    );
    const loading = (
      <div className="loading_conatiner">
        <div className="lds-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        {/*<p>Message Here...</p>*/}
      </div>
    )

    const docCards = (
      <div id="_library-products" className="grid-view">
        {
          documents && documents.length > 0 ? documents.map((item, index) => {
            return (
              <Card
                className="_library-card"
                key={index}>
                <div className="card-content">
                  <div className="card-tag">
                    {
                      item.contentType
                        ? <span className="text-capitalize">{item.contentType}</span>
                        : <span>--NA--</span>
                    }
                  </div>
                  <div className="item-img d-flex align-items-center justify-content-center">
                    {
                      item.file.conversionStatus == "PENDING" || item.file.conversionStatus == "ERROR"
                        ?
                        <img
                          className="img-fluid theme-bg-img"
                          src={processingImg}
                          alt={item.name}
                        />
                        : <img
                          className="img-fluid"
                          src={item.file.thumbUrl}
                          alt={item.name}
                        />
                    }
                  </div>
                  <CardBody>
                    <div>
                      <div className="item-name mb-1">
                        <span onClick={() => this.showDocumentDetailSidebar(item) } >{item.name}</span>
                      </div>
                      <div className="card-item-wrapper">
                        <div className="item-rating mr-2">
                          <Star fill="#7367f0" color="#7367f0" size={15} />
                          <Star fill="#7367f0" color="#7367f0" size={15} />
                          <Star fill="#7367f0" color="#7367f0" size={15} />
                          <Star fill="#7367f0" color="#7367f0" size={15} />
                        </div>
                        {
                          item.readTime
                            ? <div className="read-time">
                              <span>( {item.file.readTime} mins )</span>
                            </div>
                            : null
                        }
                      </div>
                    </div>
                    {
                      this.props.contentPicker
                        ? <Button
                          style={{ width: "100%" }}
                          className="btn mt-2"
                          color="primary"
                          onClick={() => this.selectCurentContent(item, this.props.contentSharing)}
                        >
                          Select
                      </Button>
                        : null
                    }
                  </CardBody>
                </div>
              </Card>
            )
          }) : noData
        }
      </div>

    );

    const addNewButton = <div className="actions-left d-flex flex-wrap view-btn-option">
      <Button
        color="success"
        className="btn ml-1"
        size="md"
        onClick={() => this.handleSidebar(true, true)}>
        <Plus size={15} />
        <span className="align-middle">Add</span>
      </Button>
    </div>

    const searchBar = <div className="_library-searchbar">
      <FormGroup className="position-relative mb-0">
        <Input
          className="w-100 mr-1 mb-sm-0 search-product"
          type="text"
          placeholder="search..."
          onChange={e => this.updateSearchTerm(e)}
          value={documentFilter.searchTerm}
        />
        <div className="form-control-position">
          <Search size={22} />
        </div>
      </FormGroup>
    </div>;

    const rowsPerPageDD = <div className="dropdown mr-2">
      <ButtonDropdown
        isOpen={this.state.rowsPerPageDropDownOpen}
        toggle={(e) => { this.setState({ rowsPerPageDropDownOpen: !rowsPerPageDropDownOpen }) }}
      >
        <DropdownToggle color="primary" caret>
          Items : {documentPaginator.rowsPerPage}
          <ChevronDown size={15} />
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={(e) => { this.setRowsPerPage(3) }}>3</DropdownItem>
          <DropdownItem onClick={(e) => { this.setRowsPerPage(6) }}>6</DropdownItem>
        </DropdownMenu>
      </ButtonDropdown>
    </div>

    const sortByDD = <div className="dropdown">
      <ButtonDropdown
        isOpen={this.state.sortDropDownOpen}
        toggle={(e) => { this.setState({ sortDropDownOpen: !sortDropDownOpen }) }}
      >
        <DropdownToggle color="primary" caret>
          Sort By : {documentFilter.sortBy}
          <ChevronDown size={15} />
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={(e) => { this.sortBy('name') }}>Name</DropdownItem>
          <DropdownItem onClick={(e) => { this.sortBy('size') }}>Size</DropdownItem>
        </DropdownMenu>
      </ButtonDropdown>
    </div>

    const paginatorComp = <div className="text-center">
      <PaginatorComp paginator={documentPaginator}
        onNext={this.onNext}
        onPrev={this.onPrev}
        goToPage={this.goToPage} />
    </div>

    return (
      <div className="library-content">
        <div className='data-list'>
          <Row>
            <Col sm="12">
              <div className="_library-header-items">
                <div className="library-sidebar-toggler d-block d-lg-none">
                  <Menu
                    size={26}
                    onClick={() => this.props.mainSidebar(!this.props.sidebar)}
                  />
                </div>
                <div className="d-flex justify-content-between align-items-center" style={{ width: "100%" }}>
                  {searchBar}
                  <div className="d-flex justify-content-center align-items-center">
                    {rowsPerPageDD}
                    {sortByDD}
                    {this.props.hasAddNewFunctionality ? addNewButton : null}
                  </div>
                </div>
              </div>
            </Col>
            <Col sm="12" className="mt-2">
              <div>
                {
                  isLoading ? loading :
                    <Fragment>
                      {docCards}
                      {paginatorComp}
                    </Fragment>
                }
              </div>
            </Col>
          </Row>
          {/*-------------------------Pagination-----------------*/}


          {/*-------------Overlays---------------------------*/}
          {
            !this.props.hasEditableFunctionality
              ? null
              : <Fragment>
                <EditContent
                  show={showSidebar}
                  handleSidebar={this.handleSidebar}
                  //closeDetailspage={() => { this.setState({ viewContent: false }) }}
                  //getData={this.props.getData}
                  editable={editMode}
                />
                <div
                  className={classnames("data-list-overlay", {
                    show: showSidebar
                  })}
                  onClick={() => this.handleSidebar(false)}
                />
              </Fragment>
          }

          <Fragment>
            <ShareContent
              show={shareMode}
              data={document}
              closeSharePage={() => { this.toggleShareSidebar(false) }}
            />
            <div className={classnames("share-content-overlay", {show: shareMode} )}
              onClick={() => this.toggleShareSidebar(false)} />
          </Fragment>

          <Fragment>
            <ViewContent
              show={detailMode}
              editContent={this.props.hasEditableFunctionality ? (uid) => { this.handleSidebar(true, false, uid) } : false}
              openSharePage={this.props.hasShareableFunctionality ? () => this.toggleShareSidebar(true) : false}
              closePage={() => this.toggleViewSidebar(false)}
            />
            <div className={classnames("view-content-overlay", {show: detailMode}) }
              onClick={() => this.toggleViewSidebar(false)} />
          </Fragment>
        </div>
      </div>
    );
  }
}

export default LibraryList;
